export const BACKEND_APIS = {
	CRUD: '/api/crud',
	USER: '/api/user',
	REPORTS: '/api/reports',
	EXECUTION_INFO: '/api/execution_info',
	EXECUTION_INFO_EXTRA: '/api/reports-extras/execution-info',
	EUROPCAR_ANALYTICS: '/api/search_analytics/europcar',
	HISTORICAL: '/api/historic',
	INTERMEDIARY: '/api/intermediary',
	MASTER_DATA: '/api/master-data',
	SEARCH: '/search',
	SESSION: '/api/session',
	REPORT: '/api/reports',
	REPORT_EXTRA: '/api/reports-extras',
	BATCH: '/api/batch',
	DASHBOARD: '/api/dashboard',
	CONDITIONS: '/api/alerts/conditions',
	NOTIFICATIONS: '/api/alerts/notifications',
	SEARCH_ANALYTICS: '/api/search_analytics/searches',
	SEARCH_ANALYTICS_EXCEL: '/api/search_analytics/excel',
	CUSTOM_CATEGORY: '/api/custom-categories',
	CUSTOM_ACRISS: '/api/custom-acriss',
	OFFICE_MAPPING: '/api/office-mapping',
	REPORTS_DOWNLOAD_RATING: '/api/reports/download/rating',
	REPORTS_MULTI_DOWNLOAD_RATING: '/api/reports/multi/download/rating',
	REPORTS_EXECUTIONS_RATING: '/api/reports/executions/rating',
	ADMIN: '/api/admin',
    MIGRATION: '/api/migration',
	AUTOEUROPE_PRICING_TOOL: '/api/pricing-tool/autoeurope',
}

const __ANALYZERS_PATH = '/analyzers'
export const ANALYZERS_ROUTES = {
	PATH: __ANALYZERS_PATH,
	TITLE: 'Analyzers',
	SUBTITLE: '',

	LOR_PATH: `${__ANALYZERS_PATH}/lor`,
	LOR_SUBTITLE: 'LOR Analyzer',

	DOR_PATH: `${__ANALYZERS_PATH}/dor`,
	DOR_SUBTITLE: 'DOR Analyzer',

	DIRECT_SITE_PATH: `${__ANALYZERS_PATH}/direct-site`,
	DIRECT_SITE_SUBTITLE: 'Direct Site Analyzer',

	BROKERS_PATH: `${__ANALYZERS_PATH}/brokers`,
	BROKERS_SUBTITLE: 'Brokers Analyzer',

	RATING_PATH: `${__ANALYZERS_PATH}/rating`,
	RATING_SUBTITLE: 'Rating Analyzer',

	POSITION_PATH: `${__ANALYZERS_PATH}/position`,
	POSITION_SUBTITLE: 'Position Analyzer',
}

const __ONE_WAY_PATH = '/one-way'
export const ONE_WAY_ROUTES = {
	PATH: __ONE_WAY_PATH,
	TITLE: 'One Way',
	SUBTITLE: '',

	REPORTS_PATH: `${__ONE_WAY_PATH}/reports`,
	REPORTS_TITLE: 'One Way Reports',

	ANALYZER_PATH: `${__ONE_WAY_PATH}/analyzer`,
	ANALYZER_TITLE: 'One Way Analyzer',

	ACRISS_GROUPS_PATH: `${__ONE_WAY_PATH}/acriss-groups`,
	ACRISS_GROUPS_TITLE: 'Acriss Groups',

	GROUPS_PATH: `${__ONE_WAY_PATH}/groups`,
	GROUPS_TITLE: 'Grouped Reports',

	// kept only to redirect the URLs used before the One Way menu split
	LEGACY_REPORTS_PATH: '/reports/one-ways',
	LEGACY_ANALYZER_PATH: '/analyzers/one-way',
}

export const REAL_TIME_ROUTES = {
	PATH: '/real-time',
	TITLE: 'Real time',
	SUBTITLE: 'Searches',
	SEARCHES_PATH: '/real-time/searches',
	HISTORY_PATH: '/real-time/history',
	HISTORY_TITLE: 'Historical',
	HISTORY_SUBTITLE: 'Performed Searches',
}

export const BATCH_ROUTES = {
	PATH: '/batch-list',
	TITLE: 'Batches',
	SUBTITLE: 'Executed processes',
}

const __REPORT_PATH = '/reports'
export const REPORT_ROUTES = {
	PATH: __REPORT_PATH,
	TITLE: 'Reports',
	SUBTITLE: 'List',
	MAIN_TITLE: 'Reports List',

	COMMON_PATH: `${__REPORT_PATH}/list`,
	COMMON_SUBTITLE: 'List',

	EXTRA_PATH: `${__REPORT_PATH}/extra`,
	LIST_PATH: `${__REPORT_PATH}/list`,
	EXTRA_TITLE: 'Extra Reports',
	EXTRA_SUBTITLE: 'Extra',

	RATING_PATH: `${__REPORT_PATH}/rating`,
	RATING_TITLE: 'Rating Reports',
	RATING_SUBTITLE: 'Rating',

	GROUPING_PATH: `${__REPORT_PATH}/groups`,
	GROUPING_TITLE: 'Grouped Exports',

	CONDITIONS_PATH: `${__REPORT_PATH}/conditions`,
	CONDITIONS_TITLE: 'Alert Conditions',
	NOTIFICATION_PATH: `${__REPORT_PATH}/notifications`,
	NOTIFICATION_TITLE: 'Alert Notifications',
}

const __USER_PATH = '/user'
export const USER_ROUTES = {
	PATH: __USER_PATH,
	TITLE: 'User Settings',
	SUBTITLE: '',

	SETTINGS_PATH: `${__USER_PATH}/settings`,
	SETTINGS_SUBTITLE: 'Manage Settings',
	CUSTOM_MAPPING_PATH: `${__USER_PATH}/custom-mapping`,
	CUSTOM_MAPPING_SUBTITLE: 'Custom Mapping',
}

export const SESSIONS_ROUTES = {
	LOGIN_URL: '/login',
	LOGIN_API_URL: '/loginapi',
	LOGIN_TITLE: 'Login',

	LOGOUT_URL: '/logout',
}

export const BUSINESS_LOGISTICS_ROUTES = {
	PATH: '/business-logistics',
	TITLE: 'Business Logistics',
	SUBTITLE: 'Analytics & Intelligence',

	// BI Routes
	BI_PATH: '/business-logistics/bi',
	BI_TITLE: 'BI',
	BI_SUBTITLE: 'Business Intelligence',

	// Europcar Routes
	EUROPCAR_PATH: '/business-logistics/europcar',
	EUROPCAR_TITLE: 'Europcar',
	EUROPCAR_SUBTITLE: 'Search Analytics',

	// Pricing Environment Routes
	PRICING_ENV_PATH: '/business-logistics/pricing-environment',
	PRICING_ENV_TITLE: 'Pricing Environment',
	PRICING_ENV_SUBTITLE: 'Pricing Environment',

	// Leading Analyzer Routes
	LEADING_ANALYZER_PATH: '/business-logistics/leading-analyzer',
	LEADING_ANALYZER_TITLE: 'Leading Analyzer',
	LEADING_ANALYZER_SUBTITLE: 'Leading Prices',
}

const __AUTO_EUROPE_TOOL_PATH = '/autoeurope-pricing-tool'
export const AUTO_EUROPE_TOOL_ROUTES = {
	PATH: __AUTO_EUROPE_TOOL_PATH,
	TITLE: 'AutoEurope Pricing Tool',
	SUBTITLE: 'AutoEurope',

	CONFIGURATION_PATH: `${__AUTO_EUROPE_TOOL_PATH}/configuration`,
	CONFIGURATION_TITLE: 'Configuration',
	CONFIGURATION_SUBTITLE: 'Pricing Configuration',

	PRICING_ID_PATH: `${__AUTO_EUROPE_TOOL_PATH}/pricing-id`,
	PRICING_ID_TITLE: 'Pricing ID',
	PRICING_ID_SUBTITLE: 'Pricing ID Configuration',

	PROVIDER_NORMALIZATION_PATH: `${__AUTO_EUROPE_TOOL_PATH}/provider-normalization`,
	PROVIDER_NORMALIZATION_TITLE: 'Provider Normalization',
	PROVIDER_NORMALIZATION_SUBTITLE: 'Provider Normalization Configuration',

	NOTIFICATIONS_PATH: `${__AUTO_EUROPE_TOOL_PATH}/notifications`,
	NOTIFICATIONS_TITLE: 'Notifications',
	NOTIFICATIONS_SUBTITLE: 'Pricing Tool Notifications',

	CHECKERS_PATH: `${__AUTO_EUROPE_TOOL_PATH}/checkers`,
	CHECKERS_TITLE: 'Checkers',
	CHECKERS_SUBTITLE: 'Pricing Tool Checkers',

	SEASON_SETS_PATH: `${__AUTO_EUROPE_TOOL_PATH}/season-sets`,
	SEASON_SETS_TITLE: 'Season Sets',
	SEASON_SETS_SUBTITLE: 'Season Sets Configuration',
}

export const BI_ROUTES = {
	PATH: BUSINESS_LOGISTICS_ROUTES.BI_PATH,
	TITLE: BUSINESS_LOGISTICS_ROUTES.BI_TITLE,
	SUBTITLE: BUSINESS_LOGISTICS_ROUTES.BI_SUBTITLE,
}

export const EUROPCAR_ROUTES = {
	MAIN_PATH: BUSINESS_LOGISTICS_ROUTES.PATH,
	ANALYTICS_PATH: '/europcar',
	PRICING_ENV_PATH: '/pricing-environment',
	TITLE: BUSINESS_LOGISTICS_ROUTES.EUROPCAR_TITLE,
	PRICING_ENV_SUBTITLE: BUSINESS_LOGISTICS_ROUTES.PRICING_ENV_TITLE,
	ANALYTICS_SUBTITLE: BUSINESS_LOGISTICS_ROUTES.EUROPCAR_TITLE,
}

export const GROUPING_EXPORTS_ROUTES = {
	PATH: '/grouping-exports',
	TITLE: 'Grouping Exports',
	SUBTITLE: 'History',
}

const __ADMIN_PATH = '/admin'
export const ADMIN_ROUTES = {
	PATH: __ADMIN_PATH,
	GLOBAL_EXECUTION_PATH: `${__ADMIN_PATH}/execution-status`,
	GLOBAL_EXECUTION_SUBTITLE: 'Global Execution Status',
	CUSTOM_OFFICE_PATH: `${__ADMIN_PATH}/office-mapping`,
	CUSTOM_OFFICE_SUBTITLE: 'Custom Offices Mapping',
	USER_CONFIG_PATH: `${__ADMIN_PATH}/users-config`,
	USER_CONFIG_SUBTITLE: 'Users Control Panel',
	DATA_STUDIO_SUBTITLE: 'Proxy Stats',
	DATA_STUDIO_PATH: `${__ADMIN_PATH}/proxy-stats`,
	DATA_STUDIO_SINGLE_SUBTITLE: 'Proxy Stats Single',
	DATA_STUDIO_SINGLE_PATH: `${__ADMIN_PATH}/proxy-stats-single`,
	EXPORT_CONNECTIONS_SUBTITLE: 'Export Connections',
	EXPORT_CONNECTIONS_PATH: `${__ADMIN_PATH}/export-connections`,
	PROVIDERS_WEB_SUPPLIERS_MAPPING_PATH: `${__ADMIN_PATH}/providers-suppliers-mapping`,
	PROVIDERS_WEB_SUPPLIERS_MAPPING_SUBTITLE: 'Providers & Web Suppliers Mapping',
	GROUPED_EXPORTS_PATH: `${__ADMIN_PATH}/grouped-exports`,
	GROUPED_EXPORTS_SUBTITLE: 'Grouped Exports',
	GROUPED_EXTRA_EXPORTS_PATH: `${__ADMIN_PATH}/grouped-exports-extra`,
	GROUPED_EXTRA_EXPORTS_SUBTITLE: 'Grouped Exports Extra',
	REPORT_HANDLER_SUBTITLE: 'Reports Handler',
	REPORT_HANDLER_PATH: `${__ADMIN_PATH}/reports-handler`,
	ADMIN_MAPPING_PATH: `${__ADMIN_PATH}/admin-mapping`,
	ADMIN_MAPPING_SUBTITLE: 'Admin Mapping',
	TITLE: 'Admin',
}

export const HOME_ROUTES = {
	PATH: '/main',
	TITLE: 'Main Page',
	HOME_PATH: '/main/home',
	HOME_TITLE: 'Home',
	SEARCH_ANALYTICS_PATH: '/main/search-analytics',
	SEARCH_ANALYTICS_TITLE: 'Search Analytics',
	SUBTITLE: 'User Data',
}

export const LEADING_PRICE_ROUTES = {
	PATH: BUSINESS_LOGISTICS_ROUTES.LEADING_ANALYZER_PATH,
	TITLE: BUSINESS_LOGISTICS_ROUTES.LEADING_ANALYZER_TITLE,
	SUBTITLE: BUSINESS_LOGISTICS_ROUTES.LEADING_ANALYZER_SUBTITLE,
}